import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite'; // ✅ Add observer
import BroadcastMessage from './messageBubble/BroadcastMessage';
import MediaMessage from './messageBubble/MediaMessage';
import TextMessage from './messageBubble/TextMessage';
import MessageMeta from './messageBubble/MessageMeta';

const useStyles = makeStyles((theme) => ({
  bubbleRow: { 
    display: 'flex', 
    marginBottom: theme.spacing(1) 
  },
  bubble: {
    display: 'inline-block',
    padding: theme.spacing(1, 1.5),
    borderRadius: 12,
    maxWidth: '75%',
    position: 'relative',
    wordBreak: 'break-word',
    background: '#fff',
    boxShadow: '0 1px 0 rgba(0,0,0,0.08)',
  },
  me: { 
    marginLeft: 'auto', 
    background: '#d9fdd3', 
    borderTopRightRadius: 4 
  },
  them: { 
    marginRight: 'auto', 
    borderTopLeftRadius: 4 
  },
  optimistic: {
    border: '1px dashed rgba(0,0,0,0.2)',
    backgroundColor: 'rgba(220, 248, 198, 0.7)',
  },
}));

// ✅ Wrap with observer for MobX reactivity
export default observer(function MessageBubble({ 
  message, 
  index, 
  fmtTimeID,
  getMsgId 
}) {
  const classes = useStyles();
  
  const messageType = message?.type || 'text';
  const url = message?.content?.presignUrl || message?.content?.url;
  const mime = message?.content?.mediaData?.mimeType || message?.content?.mimeType;
  const hasMedia = !!url && (
    (typeof mime === 'string' && (
      mime.startsWith('image/') || 
      mime.startsWith('video/') || 
      mime.startsWith('audio/')
    )) ||
    // For optimistic messages, also check message type
    ['image', 'video', 'audio', 'document'].includes(messageType) ||
    // For blob URLs (optimistic uploads)
    (url && url.startsWith('blob:'))
  );
  
  const isBroadcastMsg = message?.type === 'broadcast' || message?.isBroadcast;
  const isOptimistic = message?.isOptimistic;
  const msgId = getMsgId(message, index);

  return (
    <Box
      className={classes.bubbleRow}
      id={`msg-${msgId}`}
      justifyContent={message.fromMe ? 'flex-end' : 'flex-start'}
    >
      <Box 
        className={clsx(classes.bubble, {
          [classes.me]: message.fromMe,
          [classes.them]: !message.fromMe,
          [classes.optimistic]: isOptimistic,
        })}
      >
        {isBroadcastMsg ? (
          <BroadcastMessage message={message} fmtTimeID={fmtTimeID} />
        ) : (
          <>
            {hasMedia ? (
              <MediaMessage message={message} />
            ) : (
              <TextMessage message={message} />
            )}
            <MessageMeta message={message} fmtTimeID={fmtTimeID} />
          </>
        )}
      </Box>
    </Box>
  );
});